const setting = {
  
  error_language_required: "Language is required",
  error_dateformat_required: "Date Formate is required",
  error_timeformat_invalid: "Timeformat is required",
  error_startday_required: "StartDay is required",
  error_status_required:"Status is required"
};
export default setting;
